<template>
  <div class="header header-transparent">
    <div class="xs-top-bar">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <ul class="xs-top-bar-info">
              <li class="top-phone">
                <p><i class="icon icon-phone"></i>+1 508 502 7059</p>
              </li>
              <li>
                <a href="mailto:info@episcloud.com"><i
                  class="icon icon-envelope"></i>info@episcloud.com</a>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="top-menu">
              <li><a href="https://dash.episcloud.com/login"><i
                class="icon icon-key2"></i> Login </a></li>
              <li>
                <a href="https://dash.episcloud.com/login/">Support</a></li>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <header class="xs-header">
      <div class="container">
        <div class="row align-items-center">
          <div class="xs-logo-wraper">
            <a href="/" class="xs-logo">
              <img src="../assets/images/facebook_cover_photo_1-removebg-preview.png" alt="EPIS Cloud">
            </a>
          </div>
          <nav class="xs-menus ml-auto" data-close-icon="">
            <div class="nav-header">
              <a class="nav-brand" href="/">
                <img src="../assets/images/facebook_cover_photo_1-removebg-preview.png" alt="EPIS Cloud">
              </a>
<!--              <div class="nav-toggle">-->
<!--                <div class="nav-toggle-bar"></div>-->
<!--              </div>-->
            </div>
<!--            <div class="nav-menus-wrapper">-->
<!--              <ul id="main-menu" class="nav-menu">-->
<!--                <li id="menu-item-18"-->
<!--                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18 single-menu-item">-->
<!--                  <a title="Hosting" href="https://dash.episcloud.com">Hosting</a>-->
<!--                  <ul role="menu" class="nav-dropdown xs-icon-menu nav-submenu ">-->
<!--                    <li id="menu-item-726"-->
<!--                        class="menu-item menu-item-type-post_type menu-item-object-mega_menu menu-item-726 single-menu-item">-->
<!--                      <div class="megamenu-content">-->
<!--                        <div data-elementor-type="wp-post" data-elementor-id="713"-->
<!--                             class="elementor elementor-713 elementor-bc-flex-widget" data-elementor-settings="[]">-->
<!--                          <div class="elementor-inner">-->
<!--                            <div class="elementor-section-wrap">-->
<!--                              <div-->
<!--                                class="elementor-section elementor-top-section elementor-element elementor-element-275038d elementor-section-boxed elementor-section-height-default elementor-section-height-default"-->
<!--                                data-id="275038d" data-element_type="section"-->
<!--                                data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">-->
<!--                                <div class="elementor-container elementor-column-gap-default">-->
<!--                                  <div class="elementor-row">-->
<!--                                    <div-->
<!--                                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-e7cb37a"-->
<!--                                      data-id="e7cb37a" data-element_type="column">-->
<!--                                      <div class="elementor-column-wrap elementor-element-populated">-->
<!--                                        <div class="elementor-widget-wrap">-->
<!--                                          <div-->
<!--                                            class="elementor-element elementor-element-c39e63c elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"-->
<!--                                            data-id="c39e63c" data-element_type="widget"-->
<!--                                            data-widget_type="image-box.default">-->
<!--                                            <div class="elementor-widget-container">-->
<!--                                              <div class="elementor-image-box-wrapper">-->
<!--                                                <figure class="elementor-image-box-img">-->
<!--                                                  <router-link :to="{ path: 'shared-hosting' }">-->
<!--                                                    <img width="41"-->
<!--                                                         height="40"-->
<!--                                                         src="../assets/images/icon-1-1.png"-->
<!--                                                         class="attachment-full size-full"-->
<!--                                                         alt=""-->
<!--                                                         loading="lazy"/>-->
<!--                                                  </router-link>-->
<!--                                                </figure>-->
<!--                                                <div class="elementor-image-box-content">-->
<!--                                                  <h3 class="elementor-image-box-title">-->
<!--                                                    <router-link :to="{ path: 'shared-hosting' }">-->
<!--                                                      Shared Hosting-->
<!--                                                    </router-link>-->
<!--                                                  </h3>-->
<!--                                                  <p class="elementor-image-box-description">Protect your Brand</p>-->
<!--                                                </div>-->
<!--                                              </div>-->
<!--                                            </div>-->
<!--                                          </div>-->
<!--                                          <div-->
<!--                                            class="elementor-element elementor-element-a971745 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"-->
<!--                                            data-id="a971745" data-element_type="widget"-->
<!--                                            data-widget_type="image-box.default">-->
<!--                                            <div class="elementor-widget-container">-->
<!--                                              <div class="elementor-image-box-wrapper">-->
<!--                                                <figure class="elementor-image-box-img">-->
<!--                                                  <router-link :to="{ path: 'reseller-hosting' }">-->
<!--                                                    <img width="40"-->
<!--                                                         height="40"-->
<!--                                                         src="../assets/images/icon-2-1.png"-->
<!--                                                         class="attachment-full size-full"-->
<!--                                                         alt=""-->
<!--                                                         loading="lazy"/>-->
<!--                                                  </router-link>-->
<!--                                                </figure>-->
<!--                                                <div class="elementor-image-box-content"><h3-->
<!--                                                  class="elementor-image-box-title">-->
<!--                                                  <router-link :to="{ path: 'reseller-hosting' }">-->
<!--                                                    Reseller Hosting-->
<!--                                                  </router-link>-->
<!--                                                </h3>-->
<!--                                                  <p class="elementor-image-box-description"><span-->
<!--                                                    style="font-size: 14px;">Deploy</span> your Brand faster</p></div>-->
<!--                                              </div>-->
<!--                                            </div>-->
<!--                                          </div>-->
<!--                                          <div-->
<!--                                            class="elementor-element elementor-element-a9c591f elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"-->
<!--                                            data-id="a9c591f" data-element_type="widget"-->
<!--                                            data-widget_type="image-box.default">-->
<!--                                            <div class="elementor-widget-container">-->
<!--                                              <div class="elementor-image-box-wrapper">-->
<!--                                                <figure class="elementor-image-box-img">-->
<!--                                                  <router-link :to="{ path: 'vps-hosting' }">-->
<!--                                                    <img width="42"-->
<!--                                                         height="35"-->
<!--                                                         src="../assets/images/icon-3-1.png"-->
<!--                                                         class="attachment-full size-full"-->
<!--                                                         alt=""-->
<!--                                                         loading="lazy"/>-->
<!--                                                  </router-link>-->
<!--                                                </figure>-->
<!--                                                <div class="elementor-image-box-content"><h3-->
<!--                                                  class="elementor-image-box-title">-->
<!--                                                  <router-link :to="{ path: 'vps-hosting' }">-->
<!--                                                    VPS Hosting-->
<!--                                                  </router-link>-->
<!--                                                </h3>-->
<!--                                                  <p class="elementor-image-box-description">Protect your Brand</p>-->
<!--                                                </div>-->
<!--                                              </div>-->
<!--                                            </div>-->
<!--                                          </div>-->
<!--                                        </div>-->
<!--                                      </div>-->
<!--                                    </div>-->
<!--                                    <div-->
<!--                                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-8043db1"-->
<!--                                      data-id="8043db1" data-element_type="column">-->
<!--                                      <div class="elementor-column-wrap elementor-element-populated">-->
<!--                                        <div class="elementor-widget-wrap">-->
<!--                                          <div-->
<!--                                            class="elementor-element elementor-element-9ede776 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"-->
<!--                                            data-id="9ede776" data-element_type="widget"-->
<!--                                            data-widget_type="image-box.default">-->
<!--                                            <div class="elementor-widget-container">-->
<!--                                              <div class="elementor-image-box-wrapper">-->
<!--                                                <figure class="elementor-image-box-img">-->
<!--                                                  <router-link :to="{ path: 'cloud-hosting' }">-->
<!--                                                    <img width="40"-->
<!--                                                         height="40"-->
<!--                                                         src="../assets/images/icon-4-1.png"-->
<!--                                                         class="attachment-full size-full"-->
<!--                                                         alt=""-->
<!--                                                         loading="lazy"/>-->
<!--                                                  </router-link>-->
<!--                                                </figure>-->
<!--                                                <div class="elementor-image-box-content"><h3-->
<!--                                                  class="elementor-image-box-title">-->
<!--                                                  <router-link :to="{ path: 'cloud-hosting' }">-->
<!--                                                    Cloud Hosting-->
<!--                                                  </router-link>-->
<!--                                                </h3>-->
<!--                                                  <p class="elementor-image-box-description">Access your files-->
<!--                                                    anywhere</p></div>-->
<!--                                              </div>-->
<!--                                            </div>-->
<!--                                          </div>-->
<!--                                          <div-->
<!--                                            class="elementor-element elementor-element-eace3f6 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"-->
<!--                                            data-id="eace3f6" data-element_type="widget"-->
<!--                                            data-widget_type="image-box.default">-->
<!--                                            <div class="elementor-widget-container">-->
<!--                                              <div class="elementor-image-box-wrapper">-->
<!--                                                <figure class="elementor-image-box-img">-->
<!--                                                  <router-link :to="{ path: 'dedicated-hosting' }">-->
<!--                                                    <img width="40"-->
<!--                                                         height="40"-->
<!--                                                         src="../assets/images/icon-5.png"-->
<!--                                                         class="attachment-full size-full"-->
<!--                                                         alt=""-->
<!--                                                         loading="lazy"/>-->
<!--                                                  </router-link>-->
<!--                                                </figure>-->
<!--                                                <div class="elementor-image-box-content"><h3-->
<!--                                                  class="elementor-image-box-title">-->
<!--                                                  <router-link :to="{ path: 'dedicated-hosting' }">-->
<!--                                                    Dedicated Hosting-->
<!--                                                  </router-link>-->
<!--                                                </h3>-->
<!--                                                  <p class="elementor-image-box-description">Be secure, be safe</p>-->
<!--                                                </div>-->
<!--                                              </div>-->
<!--                                            </div>-->
<!--                                          </div>-->
<!--                                          <div-->
<!--                                            class="elementor-element elementor-element-e64162e elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"-->
<!--                                            data-id="e64162e" data-element_type="widget"-->
<!--                                            data-widget_type="image-box.default">-->
<!--                                            <div class="elementor-widget-container">-->
<!--                                              <div class="elementor-image-box-wrapper">-->
<!--                                                <figure class="elementor-image-box-img">-->
<!--                                                  <router-link :to="{ path: 'domain-name' }">-->
<!--                                                    <img width="40"-->
<!--                                                         height="40"-->
<!--                                                         src="../assets/images/icon-6.png"-->
<!--                                                         class="attachment-full size-full"-->
<!--                                                         alt=""-->
<!--                                                         loading="lazy"/>-->
<!--                                                  </router-link>-->
<!--                                                </figure>-->
<!--                                                <div class="elementor-image-box-content"><h3-->
<!--                                                  class="elementor-image-box-title">-->
<!--                                                  <router-link :to="{ path: 'domain-name' }">-->
<!--                                                    Domain Name-->
<!--                                                  </router-link>-->
<!--                                                </h3>-->
<!--                                                  <p class="elementor-image-box-description">Grab your domain name-->
<!--                                                    now!</p></div>-->
<!--                                              </div>-->
<!--                                            </div>-->
<!--                                          </div>-->
<!--                                        </div>-->
<!--                                      </div>-->
<!--                                    </div>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                </li>-->
<!--                <li id="menu-item-19"-->
<!--                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-19 single-menu-item">-->
<!--                  <router-link :to="{ path: 'blog' }">-->
<!--                    News-->
<!--                  </router-link>-->
<!--                  <ul role="menu" class="nav-dropdown xs-icon-menu nav-submenu ">-->
<!--                    <li id="menu-item-203"-->
<!--                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-203 single-menu-item">-->
<!--                      <router-link tag="a" :to="{ path: 'blog' }">-->
<!--                        <i class="icon icon-file-2"></i>Blog-->
<!--                      </router-link>-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                </li>-->
<!--                <li id="menu-item-712"-->
<!--                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-712 single-menu-item">-->
<!--                  <router-link tag="a" :to="{ path: 'contact' }">-->
<!--                    Contact-->
<!--                  </router-link>-->
<!--                 </li>-->
<!--              </ul>-->
<!--            </div>-->
          </nav>
          <ul class="xs-menu-tools">

<!--            <li>-->
<!--              <a href="#modal-popup-2" class="navsearch-button xs-modal-popup"><i class="icon icon-search"></i></a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a href="#" class="navSidebar-button"><i class="icon icon-burger-menu"></i></a>-->
<!--            </li>-->
          </ul>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </header>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue